/**
 * Safeguard window.WebSocket against third-party extensions or environments where it is corrupted.
 */
if (typeof window !== "undefined") {
  try {
    const isConstructible = (fn) => {
      if (typeof fn !== "function") return false;
      try {
        const ws = new fn("wss://127.0.0.1:65535");
        try { ws.close(); } catch (_) {}
        return true;
      } catch (e) {
        if (e && e.name === "TypeError" && /not a constructor/i.test(e.message)) {
          return false;
        }
        return true;
      }
    };

    if (!isConstructible(window.WebSocket)) {
      let restored = false;
      try {
        let iframe = document.getElementById("__ws_safeguard_frame__");
        if (!iframe) {
          iframe = document.createElement("iframe");
          iframe.id = "__ws_safeguard_frame__";
          iframe.style.position = "absolute";
          iframe.style.width = "0";
          iframe.style.height = "0";
          iframe.style.border = "none";
          iframe.style.left = "-9999px";
          iframe.style.top = "-9999px";
          iframe.setAttribute("aria-hidden", "true");
          iframe.setAttribute("tabindex", "-1");
          (document.head || document.documentElement).appendChild(iframe);
        }
        if (iframe.contentWindow && isConstructible(iframe.contentWindow.WebSocket)) {
          window.WebSocket = iframe.contentWindow.WebSocket;
          restored = true;
        }
      } catch (err) {}

      if (!restored) {
        class SafeDummyWebSocket {
          static CONNECTING = 0;
          static OPEN = 1;
          static CLOSING = 2;
          static CLOSED = 3;

          constructor(url, protocols) {
            this.url = url;
            this.protocols = protocols;
            this.readyState = 3;
            this.bufferedAmount = 0;
            this.extensions = "";
            this.protocol = "";
            this.binaryType = "blob";
            this.onopen = null;
            this.onclose = null;
            this.onerror = null;
            this.onmessage = null;
          }
          close() {}
          send() {}
          addEventListener() {}
          removeEventListener() {}
          dispatchEvent() { return false; }
        }
        window.WebSocket = SafeDummyWebSocket;
      }
    }
  } catch (e) {}
}

const safeguard = {};
export default safeguard;
